// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__2q85i","cell":"Pagination_cell__2irI- index_body__1cmOq","perPage":"Pagination_perPage__hPUyl index_caption__1AJ2W"};